/**
 * Shared knobs for the auth-refresh chain.
 * Centralised so timing assumptions can be reasoned about in one place.
 */
export const VERSION_CONSTANTS = {
  /** Skew window: if the access token expires within this delta, refresh preemptively. */
  EARLY_REFRESH_THRESHOLD_MS: 5 * 60 * 1000,
  /** sessionStorage key for the post-login returnUrl. */
  RETURN_URL_STORAGE_KEY: 'cesmon-return-url',
  /** sessionStorage key flagging that a chunk-load reload already happened. */
  CHUNK_RELOAD_MARKER_KEY: 'cesmon-chunk-reload-marker',
  /** Chunk reload marker TTL: anything older is considered an unrelated reload. */
  CHUNK_RELOAD_MARKER_TTL_MS: 60 * 1000,
} as const;

/**
 * Returns a safe in-app path or null. Defends against open-redirect attempts
 * via schemes (javascript:, data:), protocol-relative URLs (//host), and
 * traversal (..). Used by ReturnUrlService.
 */
export function whitelistReturnUrl(url: string | null | undefined): string | null {
  if (!url) return null;
  const trimmed = url.trim();
  if (!trimmed.startsWith('/')) return null;
  if (trimmed.startsWith('//')) return null;
  if (/^[a-z]+:/i.test(trimmed)) return null;
  if (trimmed.includes('..')) return null;
  if (trimmed.length > 2048) return null;
  return trimmed;
}
